import type { StoryId } from './stories/types'
import type { ExpoMode } from './types'

export const EXPO_PATH = '/auto-test/expo'
export const DEMO_EXPO_PATH = '/demo/auto-test/expo'

export function isExpoPath(pathname: string): boolean {
  return pathname === EXPO_PATH || pathname === DEMO_EXPO_PATH
}

/** Sales mode is an unlisted URL a presenter bookmarks; anything else is the kiosk. */
export function parseExpoMode(search: string): ExpoMode {
  return new URLSearchParams(search).get('mode') === 'sales' ? 'sales' : 'kiosk'
}

export function parseExpoStory(search: string): StoryId {
  const story = new URLSearchParams(search).get('story')
  return story === 'headlight' ? 'headlight' : 'mirror'
}
